/**
 * Componente de Ruta Protegida
 *
 * Verifica autenticación y permisos de rol antes de permitir acceso
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useUserRole } from '../hooks/useUserRole';

function ProtectedRoute({ children, allowedRoles = ['OWNER', 'ADMIN', 'COMANDA', 'STAFF'] }) {
  const { user, loading: authLoading } = useAuth();
  const { role, loading: roleLoading, canAccessComanda } = useUserRole();

  // Mostrar loading mientras se verifica autenticación
  if (authLoading || (user && roleLoading)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#7E4FB9'
      }}>
        Verificando permisos...
      </div>
    );
  }

  // Si no hay usuario, redirigir a login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Verificar si el usuario tiene permiso para acceder a comanda
  if (!canAccessComanda()) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h1>Acceso No Autorizado</h1>
        <p>Tu cuenta no tiene permisos para acceder a la aplicación de comanda.</p>
        <p>Rol actual: {role || 'Desconocido'}</p>
      </div>
    );
  }

  // Verificar roles específicos si se especifican
  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '20px',
        textAlign: 'center'
      }}>
        <h1>Acceso No Autorizado</h1>
        <p>No tienes los permisos necesarios para acceder a esta sección.</p>
        <p>Rol requerido: {allowedRoles.join(', ')}</p>
        <p>Tu rol: {role}</p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute;
